import React from "react";
import { BadgeColor, LabeledBadge } from "sprint-common-web";

export const LabeledTrailerInfoBadge = (): JSX.Element => (
    <LabeledBadge
        label="Info"
        value="Trailer"
        testId="info-field"
        badgeSize={14}
        color={BadgeColor.ApplicationPrimary}
    />
);
